export enum PredictionModel {
  GEN = "GEN",
  COL_CL = "COL_CL",
  COL_MUT = "COL_MUT",
}

export enum FeatureType {
  GENE = "GENE",
  GENE_MUTATED = "GENE_MUTATED",
  CLINICAL = "CLINICAL",
}

export interface IShapFeature {
  value: number;
  feature_type: FeatureType;
}

export interface IMlPredictionResult {
  sampleID: number;
  model: PredictionModel;
  probaSensitivity: number;
  shapValues: Record<string, IShapFeature>;
  baseValue: number;
}

export interface IPredictionCheckResult {
  ready: boolean;
  model: PredictionModel;
  missing?: string[];
  prediction?: IExposedPrediction;
}

export interface IExposedPrediction {
  id?: number;
  personalID?: number;
  model?: PredictionModel | null;
  sensitivityProbability: number;
  shapValues: Record<string, IShapFeature>;
  baseValue: number;
  createdAt?: string;
}
